const PRODUCT_DATA = {
  Cheese: {
    icon: "🧀",
    img: "https://i.postimg.cc/ZRJ1TSjb/Gemini-Generated-Image-betjn3betjn3betj.png",
    banner: "https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=1200&h=400&fit=crop",
    description: "Shredded, Diced, Blocks and Slices from Go, Amul, and D'lecta.",
    subcategories: {
      "Mozzarella": {
        products: [
          
          { name: "Mozzarella Shredded", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/QtyrYXg5/go_shredded_mozzarella_2kg_500x500.webp" },
          { name: "Mozzarella Blend ", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/j2wZrrz1/Whats-App-Image-2026-03-06-at-11-45-43-PM-removebg-preview.png" },
          { name: "Mozzarella Diced", brand: "Go Cheese", size: "1kg", img: "https://i.postimg.cc/8kYbY2bC/40327064-1-go-mozzarella-cheese-shreddeddiced.webp" },
          { name: "Mozzarella Diced IQF", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/QMWBHzTk/Whats_App_Image_2026_02_19_at_12_39_23_PM_removebg_preview.png" },
         
        
          { name: "Cheddar Diced", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/y8B6GdhB/OW-B9Q6NQF8-n-Ga-XJRr.jpg" },
          { name: "Orange Cheddar Diced", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/4dyVz5NK/OW-B9Q7q-Fwsry-PXy-Au-F.jpg" },
          { name: "Monterey Jack Diced", brand: "Go Cheese", size: "2kg", img: "https://i.postimg.cc/g0Qfft93/OW-B9Q8l-Pfbr-LDxplqt.jpg" },
          { name: "Diced Mozzarella", brand: "Amul", size: "1kg", img: "https://i.postimg.cc/Fs6gbM0r/846f820927e038c4dabca5121531e921.jpg" },
          
          { name: "Shredded Cheese", brand: "Dlecta", size: "2kg", img: "https://i.postimg.cc/FKSvpk1r/5a665359d740bf10c6f2d41eab7553dc.png" },
          { name: "Diced Pizza Topping", brand: "Dlecta", size: "1kg", img: "https://i.postimg.cc/pXjB229v/Whats-App-Image-2025-11-10-at-11-27-10-b6062737.jpg" },
        ],
      },
      "Processed Cheese": {
        products: [
          { name: "Processed Cheese Block", brand: "Go Cheese", size: "1kg", img: "https://i.postimg.cc/rsPkDqZZ/GO-Processed-Cheese-200-kg.png" },
          
          
          { name: "Processed Cheese Block", brand: "Amul", size: "1kg", img: "https://i.postimg.cc/j2LV0Gqc/Processed-Cheese-1.png" },
          { name: "Processed Cheese Block", brand: "Dlecta", size: "1kg", img: "https://i.postimg.cc/WpFjykd8/Front-7a54b105-cc50-4473-816d-331f546e644d.jpg" },
        ],
      },
      "Cheese Slices": {
        products: [
          { name: "White Cheese Slice", brand: "Go Cheese", size: "750gm+50gm (50 slices)", img: "https://i.postimg.cc/nhdQv5gL/100369165-4-go-cheese-slices-plain.webp" },
          { name: "Orange Cheese Slice", brand: "Go Cheese", size: "900g (60 slices)", img: "https://i.postimg.cc/tJfhtcYc/NTTd-BMqb8g-MAybs05t8.jpg" },
          { name: "White Cheese Slice", brand: "Amul", size: "750g", img: "https://i.postimg.cc/MGTVNxVj/229136-2-2-amul-cheese-slices.webp" },
          { name: "Orange Slice", brand: "Dlecta", size: "765g (50 slices)", img: "https://i.postimg.cc/rFMcqps2/8ffced80-02dc-454e-b898-c771358d9f89-Dlecta-Cheese-Slice(Individually-Wrapped51x15Grams)765gm.jpg" },
        ],
      },
       "Block Cheese": {
        products: [
          { name: "Milko", brand: "Go Cheese", size: "1kg", img: "https://i.postimg.cc/qB9DsjHV/product_jpeg.jpg" },
          { name: "Bake stable", brand: "Dlecta", size: "1kg", img: "https://i.postimg.cc/05LXYcRL/68f05210_9131_411b_a3bf_8ee310200816.jpg" },
          { name: "⁠Red cheddar", brand: "Dlecta", size: "2.5kg", img: "https://i.postimg.cc/ZnFNybh4/Whats-App-Image-2026-03-06-at-11-52-05-PM.jpg" },
          
        ],
      },
      "Speciality": {
        products: [
          { name: "Cream Cheese", brand: "Dlecta", size: "1kg", img: "https://i.postimg.cc/cJg6fJf9/Cream-Cheese-Front.png" },
          { name: "Mascarpone", brand: "Dlecta", size: "400g", img: "https://i.postimg.cc/zGMGD14b/Front.jpg" },
          { name: "Feta", brand: "Dlecta", size: "250g", img: "https://i.postimg.cc/fywwqWS1/Back-7b0fef08-ab9b-4a2a-a68b-9ee619a332d9.png" },
          
          { name: "Parmesan Cheese", brand: "Grand Gandola", size: "4-5kg", img: "https://i.postimg.cc/FKtrnHYc/Untitled-design-(2).png" },
          
        ],
      },
      
      "Liquid Cheese": {
        products: [
         
        
          
          { name: "Filler Cheese", brand: "Go Cheese", size: "500gm", img: "https://i.postimg.cc/sDDY7V88/pixelcut-export.png" },
         
         
        ],
      },
    },
  },

  "Sauces, Dips & Gravies": {
    icon: "🍅",
    img: "https://i.postimg.cc/SK5bf5fG/Gemini-Generated-Image-a6bdxga6bdxga6bd.png",
    banner: "https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=1200&h=400&fit=crop",
    description: "Comprehensive range of ketchups, specialized mayonnaises, and culinary cooking sauces.",
    subcategories: {
      "Ketchup": {
        products: [
          { name: "Tomato Ketchup Bottle", brand: "Veeba", size: "1.2kg", img: "https://i.postimg.cc/RZqwb4c1/2a38dd4446f3b64c452a9ad01ed9b2c3.png" },
          { name: "Tomato Ketchup Pouch", brand: "Veeba", size: "2kg", img: "https://i.postimg.cc/zGVRkNWJ/veeba-tomato-ketchup-chef-s-special-pack-of-2-900gm-each-product-images-orvlcnct8p3-p610698008-1-202.webp" },
          { name: "Tomato Ketchup Sachet", brand: "Veeba", size: "8g", img: "https://i.postimg.cc/qvtCxQTX/aa40c5faddec5f1527a589cdd9062820.png" },
          { name: "Tomato Ketchup Bulk", brand: "Golden Crown", size: "6kg", img: "https://i.postimg.cc/htGNyzyp/4e52ba61356df8020f0aa86231117e1d.png" }
        ]
      },
      "Mayonnaise": {
        products: [
          { name: "Plain & Flavoured Mayo", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/wxRKh1PX/shopping.webp" },
          { name: "Rich N Creamy Mayonnaise", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/Znd1ZQpK/maeyio.jpg" },
          { name: "Tandoori / Mint / Burger Mayo", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/RhHj9YKS/73a0c5178e42a5435e32ffd820cf7cdc.png" },
          { name: "Mayonnaise Sachet", brand: "Veeba", size: "10g portions", img: "https://i.postimg.cc/c1tqQvjf/shopping_(4).webp" }
        ]
      },
      "Dips & Spreads": {
        products: [
          { name: "Garlic Chilli Spread", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/G37FP4yN/691d5aef911e761fe41d11f7ed8acec7.png" },
          { name: "Cheese Blend & Dip", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/VkBW3mvW/shopping-(3).webp" },
          { name: "Cheese & Jalapeño Dip", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/W1bd1vSJ/909763194dd3c669a0f9d2fa8d9d38fe.png" }
        ]
      },
      "Cooking Sauces": {
        products: [
          { name: "Sriracha / Szechwan", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/RhBF55NM/shopping-(5).webp" },
          { name: "Chipotle Sauce", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/FKzkD4Lh/dc8ba53ed6dfb22e034e82cfa548017c.png" }
        ]
      },
      "Pizza & Pasta": {
        products: [
          { name: "Pizza Pasta Sauce", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/52TfWdRp/shopping-(7).webp" },
          { name: "Pizza Topping", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/SQdqNzPM/shopping-(8).webp" }
        ]
      },
      "Indian Gravies": {
        products: [
          { name: "Makhni Gravy", brand: "Veeba", size: "1kg", img: "https://i.postimg.cc/DfxkK3W1/7995a340d66d8e5a4fb93b6d2dd84e8b.png" }
        ]
      },
      "Asian Sauces": {
        products: [
          { name: "Soy / Oyster / Teriyaki", brand: "LKK", size: "Various", img: "https://i.postimg.cc/L8X0PtDc/1379acb920b57398ab0e3a696535e08e.png" },
          { name: "Sweet Chilli Sauce", brand: "Golden Crown", size: "1L", img: "https://i.postimg.cc/ZYMThvyT/image_4a1885e6_5f60_42f4_9bed_5f01429ae0e5.webp" }
        ]
      },
      "Specialty Sauces": {
        products: [
          { name: "HP / Lea & Perrins / BBQ", brand: "Assorted", size: "Various", img: "https://i.postimg.cc/BZYKxfm6/c6dcd5f1468c0ba40c7ac3c459daca5f.png" },
          { name: "Mustard Kasundi", brand: "Golden Crown", size: "1kg", img: "https://i.postimg.cc/T3XZVdBW/f8fbb9eeb072105f0ae54ee6310da78e.png" }
        ]
      }
    }
},

  "Dairy, Cream & Butter": {
  icon: "🥛",
  img: "https://i.postimg.cc/sXRwz4jz/Gemini-Generated-Image-aqr3ztaqr3ztaqr3.png",
  banner: "https://i.postimg.cc/8CnjnpWq/Gemini_Generated_Image_4lijpi4lijpi4lij.png",
  description: "Complete dairy solutions including fresh creams, butter, milk, and specialty bakery bases.",
  subcategories: {
    
    "Fresh Cream": {
      products: [
        { name: "Fresh Cream", brand: "Amul", size: "250ml / 1L", img: "https://i.postimg.cc/rwSZYf7T/02_fop_amul_fresh_cream_1l_1024x1024.avif" },
        { name: "Double Dream Fresh Cream", brand: "Rich / Graviss", size: "1L", img: "https://i.postimg.cc/PJHSL46r/9415e8107b8e9914f8864a60b0a1b1f5.png" },
        { name: "Versatié Fresh Cream", brand: "Rich", size: "1L", img: "https://i.postimg.cc/Y2JpPmvC/Versatie_Back.webp" },
        { name: "Hot Kitchen Frozen Cream", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/xjkfgP1V/RCRHK_Front.webp" }
      ]
    },

    "Whipping Cream": {
      products: [
        { name: "Sun Whipping Cream", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/9X4m1BFv/664581c7a90fbb5fc75949f0f7c9b041.png" },
        { name: "Star Whipping Cream", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/MZhWLjvh/Star_Whip_Front.webp" },
        { name: "Gold Whipping Cream", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/h4JDM0tg/Product_Image1_287d46cf_a4b4_47d3_af68_d182912153d2.webp" },
        { name: "Cheese Flavoured Topping", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/dQ7sn9tX/Cheese_Whip_Topping_Front.webp" }
      ]
    },

    "Butter": {
      products: [
        { name: "CP Butter (Salted)", brand: "Amul", size: "500g", img: "https://i.postimg.cc/Sx6jdKRp/104864_2_2_amul_butter_pasteurised.webp" },
        { name: "IP Butter", brand: "Amul", size: "500g", img: "https://i.postimg.cc/pLcVqnvz/ip-butter-amul-1000x1000-removebg-preview.png" },
        { name: "Unsalted Butter", brand: "Dlecta", size: "500g", img: "https://i.postimg.cc/DwRTL2zC/23a9c134-efee-48bf-9569-8a5c1654b6e8-Dlecta-Un-Salted-Butter(packedinplainparchmentpaper)500gm.jpg" },
        { name: "Salted Butter", brand: "Dlecta", size: "500g", img: "https://i.postimg.cc/D0pDhgJx/Table-Butter.jpg" },
        { name: "School Pack Butter Chiplets", brand: "Amul", size: "10g portions", img: "https://i.postimg.cc/fbDq4xhb/81d7c_B6t_Zs_L_SX679.jpg" },
        { name: "Butter Blister Chiplets", brand: "Amul", size: "10g portions", img: "https://i.postimg.cc/CLFLxLZ3/22be0eeb63150af88c55549554a900d5.jpg" },
        { name: "Safed Makhan", brand: "Amul", size: "500g", img: "https://i.postimg.cc/FHjCnTw4/14fdccd8448fbbf779a38b92b47e63f1.png" }
      ]
    },

    "Milk": {
      products: [
        { name: "Amul Taaza", brand: "Amul", size: "1L / 500ml", img: "https://i.postimg.cc/MGq3ky8H/7414110ab7cd6787cfe03678bf8789e6.jpg" },
        { name: "Gold Milk (Full Cream)", brand: "Amul", size: "1L", img: "https://i.postimg.cc/sxJffYNv/shopping.webp" }
      ]
    },

    "Milk Powder": {
      products: [
        { name: "Amulya Milk Powder", brand: "Amul", size: "1kg", img: "https://i.postimg.cc/XYfXLvq3/ccdfd30cdfeb3c4ed8068034afa1c14f.png" },
        { name: "Amul Creamer", brand: "Amul", size: "3g", img: "https://i.postimg.cc/zf82mn13/40303388_2_amul_dairy_creamer.webp" }
      ]
    },

    "Paneer": {
      products: [
        { name: "Frozen Malai Paneer", brand: "Amul", size: "425g / 1kg", img: "https://i.postimg.cc/XYpFHggj/shopping.webp" }
      ]
    },

    "Ghee": {
      products: [
        { name: "Cow Ghee", brand: "Amul", size: "1L", img: "https://i.postimg.cc/kgQDs5Gq/02_fop_amul_cow_ghee_tetrapack_1l_1024x1024.avif" }
      ]
    },

    "Bakery Cream Base": {
      products: [
        { name: "Truffle Base", brand: "Rich", size: "2kg", img: "https://i.postimg.cc/X7dV675q/Truffle_Base_Front_4.png" },
        { name: "Better Creme", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/667Wzh5F/Bettercreme_Front_eb6454b0_ce2c_4eba_acab_386038733d47.webp" },
        { name: "Ice Hot All-In-One", brand: "Rich", size: "1kg", img: "https://i.postimg.cc/bYGyLRNF/All_In_One_Front.webp" },
        { name: "Premium Truffle", brand: "Rich", size: "2kg", img: "https://i.postimg.cc/mZ0bnFPf/Truffle_GS_Front.webp" },
      ],
    },
  },
},
"Seasonings, Spices & Powders": {
    icon: "🧂",
    img: "https://i.postimg.cc/Sxnwv9PD/Gemini-Generated-Image-wluf7mwluf7mwluf.png",
    banner:"https://i.postimg.cc/MKQ73KDj/Gemini-Generated-Image-96v8lb96v8lb96v8.png",
    subcategories: {
      "Pizza Seasoning": {
        products: [
          { name: "Oregano Bulk ", brand: "Veeba", size: "500g ", img: "https://i.postimg.cc/kGK7563N/Mldz8BM7El-ETS97vm-Tn.jpg" },
          { name: " Sachet", brand: "Veeba", size: " 0.8g", img: "https://i.postimg.cc/VNV6qzn7/shopping_(3).webp" },
        ]
      },
      "Chilli Seasoning": {
        products: [
          { name: "Chilli Flakes Bulk ", brand: "Veeba", size: "500g ", img: "https://i.postimg.cc/6qJNFW2G/37188778a0be090ec28f95aa18db46e9.png" },,
           { name: " Sachet", brand: "Veeba", size: " 0.8g", img: "https://i.postimg.cc/BvV6TJHp/shopping_(2).webp" },
        ]
      },
      "Flavour Enhancers": {
        products: [
          { name: "MSG (Ajinimoto)", brand: "Golden Crown", size: "1kg", img: "https://i.postimg.cc/4dKt3nVq/5683a9799d832a56be56d0b6515b4f34.png" }
        ]
      },
      "Asian Seasonings": {
        products: [
          { name: "Wasabi Powder", brand: "Sakura", size: "1kg", img: "https://i.postimg.cc/TYQ4h7V9/3a940b53e231198e11286340bc847437.png" },
          { name: "Gochugaru (Korean Chilli)", brand: "Imported", size: "300g", img: "https://i.postimg.cc/FFJKb7bZ/61j-C286k-Wn-L.jpg" }
        ]
      },
      "Dry Powders": {
        products: [
          { name: "Onion ", brand: "Imported", size: "500g", img: "https://i.postimg.cc/MHhhjKH4/freshos_onion_powder_500x500.webp" },
          { name: "Cayenne Powder", brand: "Imported", size: "500g", img: "https://i.postimg.cc/Dz6kYTpj/freshos_cayenne_pepper_powder.webp" }
        ]
      },
      "Japanese Base": {
        products: [
          { name: "Hondashi", brand: "Hondashi", size: "1kg", img: "https://i.postimg.cc/m2V5hXYS/3ee85e8be83c64572f294411d697f33c.jpg" }
        ],
      },
    },
},
 "Bakery & Confectionery Essentials": {
    icon: "🍩",
    img: "https://i.postimg.cc/gkvv9jq7/Gemini-Generated-Image-p8f3ccp8f3ccp8f3.png",
    banner: "https://i.postimg.cc/zfPVPzKJ/Gemini_Generated_Image_6wr9fd6wr9fd6wr9.png",
    description: "Professional chocolate fillings, premixes, and gourmet decorations.",
    subcategories: {
      "Chocolate Fillings": {
        products: [
          { name: "Choco Filling Hazelnut", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/VkM3Mqwk/095213bfa1e5e79eb7101dd3432352cb.jpg" },
          { name: "Choco Filling Butterscotch", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/jSNGNHTL/a408db9bfc3906a708b23ed966519c5f.jpg" },
          { name: "Choco Filling Milk", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/BnDdDT3Z/83974ec54bd4d2538cfe4b183a57868e.jpg" },
          { name: "Choco Filling White", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/MpRhR7wn/c9b2517ac2619fbbe17d9ea8d724ce59.jpg" },
          { name: "Choco Filling Dark", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/x1HWHvQm/f679d7e66670f4aed8da457d2dce56ab.png" }
        ]
      },
      "Chocolate Compounds": {
        products: [
          { name: "Dark Compound D15", brand: "Morde", size: "500g", img: "https://i.postimg.cc/8zWqWRGP/739d070709a0b1c667d56aec07bb1148.png" },
          { name: "Milk Compound M21", brand: "Morde", size: "500g", img: "https://i.postimg.cc/VL2xd7x8/2be88e2dacaa0702f6660125fce13717.png" },
          { name: "White Compound W33", brand: "Morde", size: "500g", img: "https://i.postimg.cc/qMWPzm9P/5db1d730a2515eebb96a449af5d34a01.png" },
          { name: "Strawberry Flavour Compound", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/mrdkff5K/61Jiq_Kr_H31L_SX679.jpg" },
          { name: "Orange Flavour Compound", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/wBWM88rH/shopping_(1).webp" },
          { name: "Mango Flavour Compound", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/MGsH22L6/shopping_(2).webp" }
        ]
      },
      "Chips & Morsels": {
        products: [
          { name: "Dark Chocolate Chips", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/FswM7PMK/71b_X_hu_ULL_SL1500.jpg" },
          { name: "White Compound Chips", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/15bkfWky/41c0Ngr_Is_L.jpg" },
          { name: "Milk Compound Chips", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/m2Kvtdv2/81f6d_Lno_Wr_L_SX679.jpg" },
          { name: "Twin Compound Chips", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/pX3wp0g6/1_twin_compound_1_choco_chips_morde_original_imagm3q3gatzt6zz_(1).webp" }
        ]
      },
      "Cake Mix & Premixes": {
        products: [
          { name: "Vanilla Cake Mix", brand: "Calpro", size: "5kg", img: "https://i.postimg.cc/Kz1s3XMH/calpro_crystal_vanilla_eggless_cake_premix.jpg" },
          { name: "Chocolate Cake Mix", brand: "Calpro", size: "5kg", img: "https://i.postimg.cc/vB4SxRV3/calpro_eggless_black_forest_cake_mix_500x500.webp" },
          { name: "Brownie Mix", brand: "Pristine", size: "5kg", img: "https://i.postimg.cc/Bb6ZKng9/pristine-super-veg-brownie-premix.jpg" },
          { name: "All Purpose Veg Vanilla", brand: "Pristine", size: "5kg", img: "https://i.postimg.cc/fLVgS49P/f55f8fdab1ee507d74e741e01bca6cfc.jpg" },
          { name: "Super Veg Vanilla", brand: "Pristine", size: "5kg", img: "https://i.postimg.cc/k42hRrb1/c33b88783ff41ad3f4a0d00a72362a0e.jpg" },
          { name: "All Purpose Veg Chocolate", brand: "Pristine", size: "5kg", img: "https://i.postimg.cc/NMKP2hHS/shopping.webp" },
          { name: "Super Veg Chocolate", brand: "Pristine", size: "5kg", img: "https://i.postimg.cc/ZRWDvkdX/svc.jpg" }
        ]
      },
      
      "Premium Spreads": {
        products: [
          { name: "Lotus Biscoff Spread", brand: "Lotus", size: "400g", img: "https://i.postimg.cc/BbCQ4t2r/shopping-(8).webp" },
          { name: "Peanut Butter", brand: "Imported", size: "510g", img: "https://i.postimg.cc/vHxy8CTK/71irkh9ZQd_L_SX679.jpg" },
              { name: " Choco Filling Hazelnut ", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/VkM3Mqwk/095213bfa1e5e79eb7101dd3432352cb.jpg" },

       

        { name: " Choco Filling Butterscotch ", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/jSNGNHTL/a408db9bfc3906a708b23ed966519c5f.jpg" },

         { name: " Choco Filling Milk ", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/BnDdDT3Z/83974ec54bd4d2538cfe4b183a57868e.jpg" },

          { name: " Choco Filling White ", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/MpRhR7wn/c9b2517ac2619fbbe17d9ea8d724ce59.jpg" },

           { name: " Choco Filling Dark ", brand: "Morde", size: "Standard", img: "https://i.postimg.cc/x1HWHvQm/f679d7e66670f4aed8da457d2dce56ab.png" },
        ]
      },
      "Biscuits": {
        products: [
          
          { name: "Savoiardi Ladyfingers", brand: "Assorted", size: "200g", img: "https://i.postimg.cc/7Ps2grKY/shopping_(1).webp" }
        ]
      },
      "Sugar & Syrups": {
        products: [
          { name: "Sugar Sachet White", brand: "Golden Crown", size: "5g", img: "https://i.postimg.cc/250RSKT6/SUGAR_SACHETS.jpg" },
          { name: "Sugar Sachet Brown", brand: "Golden Crown", size: "5g", img: "https://i.postimg.cc/zBLWf3K9/Brown_Sugar_Sachet_1.webp" },
          { name: "Sugar Cube", brand: "Golden Crown", size: "500g", img: "https://i.postimg.cc/wvtJB3Lf/81b728_c25c8c416ca34d97be285eda834e4393_mv2.avif" },
          
          { name: "Sugar Syrup", brand: "Golden Crown", size: "1L", img: "https://i.postimg.cc/76C7LbSx/Group_1932_11.webp" },
          { name: "Pancake Syrup", brand: "American Garden", size: "710ml", img: "https://i.postimg.cc/SKCHgbsz/5879_1_70b2b493_c2b6_46d9_83c5_1234f4ab0385.webp" },
          { name: "Maple Syrup", brand: "Freshos", size: "355ml", img: "https://i.postimg.cc/BvHRmf6x/717l_Uyrjx9L.jpg" },
          { name: "Honey", brand: "Golden Crown", size: "1kg", img: "https://i.postimg.cc/xCkHdqMP/1335ca60d1c6c6886aa762173226859a.png" }
        ]
      },
      "Bakery Essentials": {
        products: [
          { name: "Baking Powder", brand: "Assorted", size: "500g", img: "https://i.postimg.cc/mZ5bG11v/2ffc20dc_975f_4732_a74d_416515ca1c62.png" },
          { name: "Baking Soda", brand: "Assorted", size: "500g", img: "https://i.postimg.cc/mZ5bG11v/baking-soda.png" },
          { name: "Active Dry Yeast", brand: "Assorted", size: "500g", img: "https://i.postimg.cc/mZ5bG11v/yeast.png" },
          { name: "Savoiardi Ladyfingers", brand: "Assorted", size: "200g", img: "https://i.postimg.cc/7Ps2grKY/shopping_(1).webp" },
          { name: "Lotus Biscoff Spread", brand: "Lotus", size: "400g", img: "https://i.postimg.cc/BbCQ4t2r/shopping-(8).webp" }
        ]
      }
    }
},

  "Frozen Snacks": {
    icon: "🍟",
    img: "https://i.postimg.cc/kXt6N3Nh/Gemini-Generated-Image-v27hiev27hiev27h.png",
     banner: "https://i.postimg.cc/xCnNzxv1/Gemini_Generated_Image_3y0q7u3y0q7u3y0q.png",
    description: "Full range of McCain commercial frozen products.",
    subcategories: {
      "Fries": {
        products: [
          { name: "Favorita 6mm", brand: "McCain", size: "2.5kg", img: "https://i.postimg.cc/MTfKNZ5B/shopping.webp" },
          { name: "Regular 6mm", brand: "McCain", size: "2.5kg", img: "https://i.postimg.cc/3J14gRcR/ee611f411106f1ebb7c80a9ff9880a3b.png" },
          { name: "favorita 9mm", brand: "McCain", size: "2.5kg", img: "https://i.postimg.cc/HLhk68wk/54e939cc954df492bbfc600f9c29e8a5.png" },
          {name : "Regular 9mm", brand: "McCain", size: "2.5kg", img: "https://i.postimg.cc/Zn7m51wh/3dd3ecddb97fb4c54e21b4c9400f9b4d.png"},
          { name: "Surecrisp 9mm", brand: "McCain", size: "3kg", img: "https://i.postimg.cc/76JYdP9H/b89119b1629a90ef9fd9f3fe6ea16f23.png" },
          
         
        ],

      },
      "Wedges": {
        products: [
          
          
         { name: "Savoury Wedges", brand: "McCain", size: "2.5kg", img: "https://i.postimg.cc/XJB7mNLB/shopping_(2).webp" },
        ],

      },
      "Veg Patties": {
        products: [
         
          { name: "Herb Chilli Patty", brand: "McCain", size: "1.5kg", img: "https://i.postimg.cc/zfcGxHCV/a739af7b29730a52f91872139b54cfae.png" },
          { name: "Popular Veggie Burger Patty", brand: "McCain", size: "1.5kg", img: "https://i.postimg.cc/pT5X4VCL/cc91a86c2d2a66810db10fb92f870cfe.png" },
          { name: "Paneer Patty", brand: "McCain", size: "1.5kg", img: "https://i.postimg.cc/d0xV5Z21/21f066870fcbced03cd032476cb2c947.png" },
          { name: "Aloo Tikki", brand: "McCain", size: "1.5kg", img: "https://i.postimg.cc/1tnLqB59/0f3b6f31182407e17d5d56e17eff6b85.png" },
        ],
      },
      "Veg Bites & Nuggets": {
        products: [
          { name: "Veggie Nuggets", brand: "McCain", size: "1kg", img: "https://i.postimg.cc/g0JvwRz5/NKrg87Lj.jpg" },
          { name: "Veggie Fingers", brand: "McCain", size: "1kg", img: "https://i.postimg.cc/yd3Yt6jk/cc396263f0de26a75d38fbf6dee300e8.png" },
          { name: "Potato Cheese Shots", brand: "McCain", size: "1kg", img: "https://i.postimg.cc/jjFSMnHC/5151dd2898c67f067c12bbe4897d4aac.png" },
          { name: "Cheese Triangles", brand: "McCain", size: "1kg", img: "https://i.postimg.cc/qR6MSBwg/d6193841ed5a170b55ae992e4856251f.jpg" },
          { name: "Chilli Garlic Pops", brand: "McCain", size: "1.5kg", img: "https://i.postimg.cc/pd6Ls5fX/0f2d7d9a3cd1905c734ea2f2312419eb.png" },
        ],
      },
      "Snack Sheets": {
        products: [
          { name: "Spring roll Sheet", brand: "Assorted", size: "1kg", img: "https://i.postimg.cc/CK78P6fZ/Whats-App-Image-2026-02-20-at-12-17-16-AM.jpg" },
          
          
        ],
      },
    },
  },

 "Canned, Preserved & Pickled Foods": {
    icon: "🥗",
    img: "https://i.postimg.cc/3JSyHr8C/1770551314698.png",
    banner: "https://i.postimg.cc/fbBSY78Q/Gemini_Generated_Image_u945jsu945jsu945.png",
    description: "Premium preserved vegetables, fruits, and gourmet pantry staples.",
    subcategories: {
      "Mushrooms": {
        products: [
          { name: "Button Mushroom Whole", brand: "Golden Crown", size: "400g / 800g / 3kg", img: "https://i.postimg.cc/mrbmmtb3/60ce8c53d7867d6e78e69a866181d1e7.png" },
           { name: "Button Mushroom Sliced", brand: "Golden Crown", size: "400g / 800g / 3kg", img: "https://i.postimg.cc/SxLCfYxR/shopping_(4).webp" },
        ]
      },
      "Vegetables": {
        products: [
          { name: "Baby Corn", brand: "Golden Crown", size: "400g / 800g", img: "https://i.postimg.cc/SKyggJy5/aeb9588f45ebe04a740aceed823b6ee3.png" },
          { name: "Bamboo Shoots", brand: "Imported", size: "800g", img: "https://i.postimg.cc/brcPDxhR/download-(4).png" },
          { name: "Water Chestnuts", brand: "Golden Crown", size: "800g", img: "https://i.postimg.cc/kghkRQNh/water-chestnut.png" }
        ]
      },
      "Corn Products": {
        products: [
          { name: "Sweet Corn Kernels", brand: "Golden Crown", size: "400g", img: "https://i.postimg.cc/kghkRQNh/9e4567deec97c1af0356a8a3a772954a.png" },
          { name: "Cream Style Corn", brand: "Golden Crown", size: "400g", img: "https://i.postimg.cc/DfDrvKNP/51Oxm2XDQw_L_AC_UF894_1000_QL80.jpg" }
        ]
      },
      "Tomatoes": {
        products: [
          { name: "Whole Peeled Tomatoes", brand: "Golden Crown", size: "2.5kg", img: "https://i.postimg.cc/vZ7P7Wd7/2b626bba947bb68fe7ec72d4545920b3.png" },
          { name: "Tomato Puree", brand: "Golden Crown", size: "850g", img: "https://i.postimg.cc/66SrWNPG/5a30fefa5e8f5abff4299b9343e701b9.png" }
        ]
      },
      "Fruits": {
        products: [
          { name: "Pineapple Slice", brand: "Golden Crown", size: "850g", img: "https://i.postimg.cc/QMXffH8r/f08541d4f76dc8e3d68fea9d667ef0da.png" },
          { name: "Fruit Cocktail", brand: "Golden Crown", size: "850g", img: "https://i.postimg.cc/BvqmmXqz/b84e6a7f91d794f137e86624383ba3b2.png" },
          { name: "Mango Pulp", brand: "Golden Crown", size: "850g", img: "https://i.postimg.cc/R0MggNMk/c4509a8a02cb9b920a3ab710ae717be5.png" }
        ]
      },
      "Olives & Jalapeños": {
        products: [
          { name: "Pitted Black Olives Sliced", brand: "Golden Crown", size: "400g / 3kg", img: "https://i.postimg.cc/CxTfFfyN/0ce567d7146db166485a2dded9954c59.webp" },
          { name: "Jalapeño Slices", brand: "Golden Crown", size: "680g / 3kg", img: "https://i.postimg.cc/5NW96V4h/shopping-(3).webp" }
        ]
      },
      "Pickled Items": {
        products: [
          { name: "Gherkins", brand: "Golden Crown", size: "800g", img: "https://i.postimg.cc/L8kykzM3/7bdf3255b028e134a8963945ecdf48c8.png" },
          { name: "Pickled Ginger", brand: "Voila", size: "1.6kg", img: "https://i.postimg.cc/2S6XWQTr/bc6c41f7512c21afea158b21ff908705.jpg" },
          { name: "Pickled Radish", brand: "Nostimo", size: "500g", img: "https://i.postimg.cc/nhzwm4Th/da7a2d717ad3fdd4d4540e026851263b.jpg" }
        ]
      },
      "Gourmet Preserved": {
        products: [
          { name: "Sundried Tomatoes", brand: "Imported", size: "1kg", img: "https://i.postimg.cc/P5n1DQTj/Dried_Tomatoes_3_square_500x375.jpg" },
          { name: "Capers", brand: "Imported", size: "100g / 500g", img: "https://i.postimg.cc/2SNnW7mK/500x500.png" }
        ]
      },
      "Others": {
        products: [
          { name: "Mixed Pickle", brand: "Golden Crown", size: "1kg / 5kg", img: "https://i.postimg.cc/yYMP7SdJ/Screenshot-2026-03-07-201312.png" },
          { name: "Red Cherry", brand: "Golden Crown", size: "850g", img: "https://i.postimg.cc/SKyggJy6/257b999bdeafad2a846d7d79c442b896.png" },
          { name: "White Asparagus", brand: "Golden Crown", size: "500g", img: "https://i.postimg.cc/VLCj5VyR/694d089a480cee77efe5cdbb3fe2642f.jpg" }
        ]
      }
    }
},
  Beverage: {
    icon: "🍹",
    img: "https://i.postimg.cc/0yjw6MWW/1770551309525.png",
     banner: "https://i.postimg.cc/L6by3f0Y/Gemini_Generated_Image_n7kxo9n7kxo9n7kx.png",
    description: "Veeba Barisco cocktail and coffee syrups.",
    subcategories: {
      "Cocktail Syrups": {
        products: [
          { name: "Mojito Mint", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/mD0M5gxS/27a5c98ce09f5ee1be1759a737ebb56d.png" },
          { name: "Blue Curacao", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/90ZT5HVG/c72c32deda7785149bb5bcac46f4a0b6.png" },
          { name: "Green Apple", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/mD0M5gxN/2d45ddcff7bd92012890ac718bb18a97.png" },
          { name: "Grenadine", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/d1zdxVMj/6b7a99357479e2724447bb5a3be6e6ea.png" },
          { name: "Kala Khatta", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/yxc94CB9/595b0313ab84d74bff124ee098b1057f.png" },
        ],
      },
      "Coffee Syrups": {
        products: [
          { name: "Vanilla", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/HnX5D1HX/3475b8209f5561d9f2f0b0d250832775.png" },
          { name: "Caramel", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/HnX5D1Hb/Barisco_Caramel_Listing_FOP_removebg_preview_(1).png" },
          { name: "Hazelnut", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/wMLJ8YHk/d7351b6c4d702ca15afcb4553bd28596.png" },
          { name: "Irish Creme", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/4drtSxCP/142b18d059f2ba3776f618a720cb877a.png" },
        ],
      },
      "Olive Oil": {
        products: [
          { name: "Pomance Olive Oil", brand: "Golden Crown", size: "1L", img: "https://i.postimg.cc/fL32JbWr/golden_crown_olive_oil_25_07_2020_012_185826570_cl16x.jpg" },
           { name: "Extra Virgin Olive Oil", brand: "Golden Crown", size: "1L", img: "https://i.postimg.cc/W3DWh4pf/golden_crown_extra_virgin_olive_oil_25_07_2020_013_185826571_z4jw2.avif" },
          
        ],
      },
      "Vinegar": {
        products: [
          { name: "Synthetic Vinegar", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/D0nx5Pd9/e71d9928b31decbdd7f35c1e1df27230.png" },
          { name: "Balsamic Vinegar", brand: "Veeba Barisco", size: "775ml", img: "https://i.postimg.cc/25WTDK0t/61iod-Z1SYc-L-SX679.jpg" },
          
        ],
      },
      
      
    },
  },

  

    "Frozen (Non-Veg)": {
    icon: "❄️",
    img: "https://i.postimg.cc/8CbJMdc6/Gemini_Generated_Image_pcjgw2pcjgw2pcjg.png",
     banner: "https://i.postimg.cc/gc7H6p7Y/Gemini_Generated_Image_r6id1hr6id1hr6id.png",
    subcategories: {"Raw Chicken": {
        products: [
           { name: "Curry cut chicken", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/pL336qKd/Screenshot_2026_03_07_010100.png" },
          { name: "Drumsticks", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/3wpz5mZ5/Screenshot_2026_03_07_010104.png" },
          { name: "Wings", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/43tjkV1J/Screenshot_2026_03_07_010107.png" },
          { name: "Whole Legs", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/N0TZqmxs/Screenshot_2026_03_07_010112.png" },
          { name: "Whole Chicken With Skin", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/yN924cT6/Screenshot_2026_03_07_010118.png" },
          { name: "Whole Chicken Without Skin", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/BvDR9HCQ/Screenshot_2026_03_07_010121.png" },

         
        ]
      },
      
      "Boneless & Keema": {
        products: [
          { name: "Leg Boneless", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/fbct3qKM/shopping-(5).webp" },
          { name: "Thing Boneless", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/7ZjjWmSY/Screenshot_2026_03_07_010057.png" },
          { name: "Breast Boneless", brand: "Assorted Brands", size: "2kg" , img: "https://i.postimg.cc/9QssnJyX/Screenshot_2026_03_07_010054.png" },
          { name: "Venkys Chicken Keema", brand: "Assorted Brands", size: "250g" , img: "https://i.postimg.cc/CxWknqpc/shopping-(4).webp" },
          

            

      
        ], 
      },
      "Cold Cuts": {
        products: [
          { name: "Smoked chicken breasts", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/vT3542Gs/40198024-1-fresho-smoked-chicken-breast.webp" },
          { name: "Chicken Cocktail Sausages", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/8cVZRY8B/Screenshot_2026_03_07_012126.png" },
          { name: "Chicken Breakfast sausage", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/4yTW60C1/Screenshot_2026_03_07_012122.png" },
          { name: "Chicken Salami (precut)", brand: "Assorted Brands", size: "250g/500g" , img: "https://i.postimg.cc/D0KxrNVP/Screenshot_2026_03_07_012247.png" },
          { name: "⁠Chicken Salami (whole)", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/X7sgqqvZ/shopping-(3).webp" },
          { name: "⁠Chicken Pepperoni", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/Y0wd6Pc8/Screenshot_2026_03_07_012350.png" },
          { name: "Chicken Seekh kebab", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/brjmx5X3/Screenshot_2026_03_07_012412.png" },
          
          

            

      
        ], 
      },
       "Ready To Eat": {
        products: [
          { name: "Chicken nuggets", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/RhDzV96k/Screenshot_2026_03_07_011506.png" },
          { name: "⁠Chicken popcorn", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/7hWyYDGp/Screenshot_2026_03_07_011511.png" },
          { name: "⁠Chicken Burger Patty", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/wMvpp3Mx/Screenshot_2026_03_07_011452.png" },
          { name: "Chicken Super Burger patty", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/jq995Mk4/shopping-(2).webp" },
          { name: "⁠Chicken Grilled patty", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/DzFRhmpX/2565130357a2a088f5a18f119078ba59.png" },
          { name: "⁠Hot & Crispy Wings", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/JnFTshKM/d9f4ec00834b6b4faed2c8db2bbfc85b.png" },
          { name: "Tandoori Wings", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/3xyxGfK7/Screenshot_2026_03_07_011330.png" },
          
          

            

      
        ], 
      },
      "Meat": {
        products: [
          { name: "Lamb", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/nLj9Hcsh/c51fc109b8de46ef49e4868f38510de3.png" },
          { name: "⁠Mutton curry cut", size: "1kg" , img: "https://i.postimg.cc/gjwvQqVF/Whats_App_Image_2026_03_07_at_12_42_56_AM_(5).jpg" },
          { name: "⁠Mutton boneless", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/d378pm2M/Whats_App_Image_2026_03_07_at_12_42_56_AM_(3).jpg" },
          { name: "⁠Duck", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/rFjrjHXx/10000994-3-fresho-duck-with-skin-cleaned-and-cut.webp" },
          { name: "⁠Turkey", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/8cV6XQzb/shopping-(1).webp" },
          { name: "⁠Mutton Keema", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/fy3xpjcQ/Whats_App_Image_2026_03_07_at_12_42_56_AM_(4).jpg" },
          { name: "Mutton Biryani cut", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/hvJ96bLc/Whats_App_Image_2026_03_07_at_12_42_56_AM.jpg" },
          
          

            

      
        ], 
      },
      "Seafood": {
        products: [
          { name: "Vietnamese Basa", brand: "Safako", size: "2.5kg" , img: "https://i.postimg.cc/vZtBvgp0/Whats_App_Image_2026_03_06_at_11_42_59_PM.jpg" },
          { name: "Indian Basa", brand: "Safako", size: "1kg" , img: "https://i.postimg.cc/13rtKnLM/Whats_App_Image_2026_03_06_at_11_42_16_PM.jpg" },
          { name: "Prawns", brand: "Safako", size: "8/12" , img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg" },
          { name: "Prawns", brand: "Safako", size: "13/15" , img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg" },
          { name: "Prawns", brand: "Safako", size: "16/20" , img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg" },
          { name: "Prawns", brand: "Safako", size: "21/25" , img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg" },
          { name: "Prawns", brand: "Safako", size: "51/60" , img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg" },
          { name: "Squid", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/PJ72hnn0/10000967_8_fresho_squid_medium_without_head_15_20_pcs.webp" },
          { name: "Tuna", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/ZYsf6pvH/tuna_fish.jpg" },
          { name: "Crab", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/cCzXZGNG/Big_Kingcrab.avif" },
          { name: "Betki", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/kGHf9PdV/sea_bass_betki_500x500.webp" },
          { name: "Lobsyer", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/QCz0sZrd/download.jpg" },
          { name: "Scallops", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/7PtBS0JV/Hotate_shell.webp" },
          { name: "Pomfret", brand: "Assorted Brands", size: "1kg" , img: "https://i.postimg.cc/VvhD1PPV/155349_6_fresho_pomfret_white_large_preservative_free_6_8_pcs.webp" },
        ] 
      },
      
    },
    },
    "Frozen (Veg)": {
    icon: "❄️",
    img: "https://i.postimg.cc/Y9q434LY/Gemini_Generated_Image_6wdqof6wdqof6wdq.png",
     banner: "https://i.postimg.cc/gc7H6p7Y/Gemini_Generated_Image_r6id1hr6id1hr6id.png",
    subcategories: {"Vegetables": {
        products: [
          { name: "Green Peas", brand: "Generic", size: "1kg", img: "https://i.postimg.cc/nhyN1vrS/shopping_(2).webp"  },
          { name: "Sweet Corn", brand: "Generic", size: "1kg" , img: "https://i.postimg.cc/YC5Tx10y/shopping.webp" },
          { name: "Soya Chaap", brand: "Generic", size: "500gm" , img: "https://i.postimg.cc/RZk2TchG/099221eb5c232fb0798f2f3bd7ac1deb.png" },
          { name: "Edamame", brand: "Imported", size: "500gm", img: "https://i.postimg.cc/2Ssgx4yH/shopping_(1).webp"  },
         
        ]
      },
      "Pastry & Desert Sheets": {
        products: [
       { name: "Kataifi Pastry", brand: "Assorted Brands", size: "1kg", img: "https://i.postimg.cc/XvSxShq0/antoniou-kataifi-frozen-string-pastry-375g-freezer-baking-cooking-ingredients-14192622501961-600x600.jpg" },
          { name: "⁠Puff pastry", brand: "Assorted Brands", size: "1kg", img: "https://i.postimg.cc/05FwBSrf/shopping_(9).webp" },
          { name: "⁠Filo Pastry", brand: "Assorted Brands", size: "1kg", img: "https://i.postimg.cc/ydWDf6K7/Screenshot-2026-03-07-014234.png" },
        ] 
      }
    },
    },
    
  "Pasta Noodles,Rice & Staples": {
    icon: "🍜",
    img: "https://i.postimg.cc/BbvrhpML/Gemini_Generated_Image_ecte69ecte69ecte.png",
     banner: "https://i.postimg.cc/cCKDgbFB/Gemini-Generated-Image-3l319n3l319n3l31.png",
    description: "Noodles,rice & Staples.",
    subcategories: {
     "Asian Noodles": {
        products: [
          
          

          { name: "Bean Thread Noodle", brand: "Imported", size: "500gm", img: "https://i.postimg.cc/XNHCw6sy/shopping_(3).webp" },
          { name: "Rice Stick 3mm", brand: "Imported", size: "500gm" , img: "https://i.postimg.cc/wxfmhYwz/4d546889691797476f36a9a44a2d8857.jpg"},
           { name: "Rice Stick 5mm", brand: "Imported", size: "500gm" , img: "https://i.postimg.cc/wxfmhYwz/4d546889691797476f36a9a44a2d8857.jpg"},
            { name: "Rice Stick 10mm", brand: "Imported", size: "500gm" , img: "https://i.postimg.cc/wxfmhYwz/4d546889691797476f36a9a44a2d8857.jpg"},
          { name: "Soba Ramen", brand: "Yoka", size: "300gm" , img: "https://i.postimg.cc/8C2dXz4r/9c0e7557f3da1097487513271226ef94.jpg"},
           { name: "Udon Ramen", brand: "Yoka", size: "300gm" , img: "https://i.postimg.cc/JhkZXW8W/dea4bcd3c09241a1b230363aad562628-(1).png"},
        ]
        
    },
    "Italian Pasta": {
        products: [
          
          

          { name: "Penne ", brand: "Golden Crown", size: "500gm", img: "https://i.postimg.cc/2jZjf8wB/product-jpeg.jpg" },
          { name: "Macaroni", brand: "Golden Crown", size: "500gm" , img: "https://i.postimg.cc/zBhs43r3/u-MGg-Iw3Y-800-800.webp"},
           { name: "Spaghetti", brand: "Golden Crown", size: "500gm" , img: "https://i.postimg.cc/Fz54K3ZR/a9b74559b5a300660ffa1c0538cb0949.png"},
            { name: "Lasagne", brand: "Golden Crown", size: "500gm" , img: "https://i.postimg.cc/x1FBCLjX/GC-2019-142.jpg"},
            { name: "Fusilli", brand: "Golden Crown", size: "500gm" , img: "https://i.postimg.cc/PxKWXQhZ/af5c8f41f9b55040041f390639a8d26f.png"},

          
        ]
        
    },
    "Rice": {
        products: [
          { name: "Jasmine Rice", brand: "Imported", size: "2kg", img: "https://i.postimg.cc/FzkQzztn/shopping_(5).webp" },
          
          

          
        ]
        
    },
     "Health Grains": {
        products: [
          
          { name: "Black Quinoa", brand: "Imported", size: "500g", img: "https://i.postimg.cc/RVPby9j4/61A94qzpjx_L.jpg" },
           { name: "White Quinoa", brand: "Imported", size: "500g", img: "https://i.postimg.cc/3xVfr18s/Screenshot-2026-03-07-021517.png" },
            { name: "Red Quinoa", brand: "Imported", size: "500g", img: "https://i.postimg.cc/HsSPRHf0/Whats_App_Image_2025_07_04_at_5_58_36_PM.jpg" },
            

        
        ]
        
    },
    "Breakfast Cereals": {
        products: [
          
          { name: "Oats", brand: "Assorted Brands", size: "500g", img: "https://i.postimg.cc/63BgqK4Q/61Vm-XAwkcj-L-SY741.jpg" },
           { name: "Corn Flakes", brand: "Assorted Brands", size: "500g", img: "https://i.postimg.cc/CKTWykF0/3PUp-Ah-Jq-800-800.webp" },
            

        
        ]
        
    },
   "Starch & Binders": {
         products: [
         
          
          { name: "Potato Starch", brand: "Assorted", size: "1kg", img: "https://i.postimg.cc/HsWYRGST/shopping-(1).webp" },
          { name: "Wheat Strach", brand: "Assorted", size: "500g", img: "https://i.postimg.cc/gjqnzSmf/5d57b2f92e7062d87d0d6b5303628643.png" },
        ]
      },
    
      
    },
  },


 "Asian & International Cooking Essentials": {
    icon: "🥢",
    img: "https://i.postimg.cc/QC7Sn7vt/Gemini-Generated-Image-69qwch69qwch69qw.png",
    banner: "https://i.postimg.cc/cH56j9SW/Gemini_Generated_Image_ck1vldck1vldck1v.png",
    description: "Authentic ingredients for professional Asian and International cuisine.",
    subcategories: {
      "Flour & Batter": {
        products: [
          { name: "Tempura Flour", brand: "Mr Hung / Welna", size: "1kg / 700gm", img: "https://i.postimg.cc/ncTPMR40/04e8b857538f3325a5fef100652e5563.png" },
          { name: "Red Lotus Flour (Special Flour)", brand: "Red Lotus", size: "1kg", img: "https://i.postimg.cc/gk4TrSVV/2d6ed3d1b297bbfc02d5019f5d34bbc8.jpg" },
          { name: "HK Flour (Wheat Starch)", brand: "Imported", size: "1kg", img: "https://i.postimg.cc/Y0hHWs3G/41Xu2kfr_D2L.jpg" },
          { name: "Potato Starch", brand: "Imported", size: "1kg", img: "https://i.postimg.cc/P5RVQCFd/Hisashi_Natural_Potato_Starch_1Kg_min_scaled.jpg" }
        ]
      },
      "Sushi Essentials": {
        products: [
          { name: "Sushi Nori Sheet", brand: "yoka", size: "125g (Pack of 50)", img: "https://i.postimg.cc/wTCnsZ1T/shopping-(5).webp" },
          { name: "Rice Paper", brand: "Imported", size: "400gm", img: "https://i.postimg.cc/cLH53RTW/a989be971940bed170e38b882785f480.png" },
          { name: "Wasabi Paste", brand: "Sakura", size: "43g", img: "https://i.postimg.cc/15Mj4C0x/71fk_Aa33Zf_L_SL1500.jpg" },
          { name: "Sushi Rice", brand: "Imported", size: "1kg", img: "https://i.postimg.cc/L4C1zFx9/61f5wws_OVe_L_SX679.jpg" }
        ]
      },
      "Korean Essentials": {
        products: [
          { name: "Gochujang (Chilli Paste)", brand: "Imported", size: "500g", img: "https://i.postimg.cc/YCsDzvyC/shopping.webp" },
          { name: "Gochugaru (Chilli Powder)", brand: "Imported", size: "300gm", img: "https://i.postimg.cc/FFJKb7bZ/61j-C286k-Wn-L.jpg" },
          { name: "Kimchi Sauce", brand: "Imported", size: "1L", img: "https://i.postimg.cc/gJhPh69w/shopping-(4).webp" }
        ]
      },
      "Japanese Essentials": {
        products: [
          { name: "Miso Paste (Shiro/Aka)", brand: "Sakura", size: "1kg", img: "https://i.postimg.cc/520kzBpN/c3b0de2acbc0b4669f6b983d46833a50.jpg" },
          { name: "Mirin", brand: "Imported", size: "500ml / 1.8L", img: "https://i.postimg.cc/8z0Xm7n5/Umai_Hon_Mirin_500ml_Authentic_Japanese_Cooking_Rice_Wine_for_Dishes_Luckystore_60015773.webp" },
          { name: "Sake", brand: "Sakura", size: "500ml / 1.8L", img: "https://i.postimg.cc/TYQ4h7VN/5dbd5eda1ef8ffde804380bbac9e5399.jpg" },
          { name: "Hondashi (Japanese Powder)", brand: "Hondashi", size: "1kg", img: "https://i.postimg.cc/m2V5hXYS/3ee85e8be83c64572f294411d697f33c.jpg" }
        ]
      },
      "Chinese Essentials": {
        products: [
          { name: "Shaoxing Wine", brand: "Double Phoenix", size: "640ml", img: "https://i.postimg.cc/Bn6wFTNb/e11caace2e4e93032baf7fd90e5addcc.jpg" },
          { name: "Chinkiang Vinegar", brand: "Imported", size: "550ml", img: "https://i.postimg.cc/cLbkBv51/shopping_(3).webp" },
          { name: "Dark Soy Sauce", brand: "LKK", size: "500ml", img: "https://i.postimg.cc/T3wHbVQR/c4e50257daae983e5eb57bd3b48fe7a5.png" },
          { name: "Light Soy Sauce", brand: "LKK", size: "500ml", img: "https://i.postimg.cc/nc20nWvL/LIGHT-SOY-SAUCE-PET-500ml-INUpdated-JPG.jpg" },
        ]
      },
      "Thai Essentials": {
        products: [
          { name: "Coconut Milk & Cream", brand: "Chaokoh", size: "400ml", img: "https://i.postimg.cc/rwmY41g2/a4fa57aa18b9aa8f93e2b84c4f2e77e2.png" },
          { name: "Fish Sauce", brand: "Tiparos", size: "700ml", img: "https://i.postimg.cc/kg4hSQwd/aa3a83dc1c9f6de9470723e8ce25871e.jpg" },
          { name: "Thai Sweet Chilli", brand: "Golden Crown", size: "1L", img: "https://i.postimg.cc/ZYMThvyT/image_4a1885e6_5f60_42f4_9bed_5f01429ae0e5.webp" },
        ],
      },
      "Oils": {
        products: [
          { name: "Sesame Oil", brand: "Double Dragon / LKK", size: "Various", img: "https://i.postimg.cc/zfNh0718/Pure_Sesame_Oil_444ML_CSA.png" },
        ]
      },
      "Premium Add-Ons": {
        products: [
          { name: "White Truffle Oil", brand: "Urbani", size: "250ml", img: "https://i.postimg.cc/wjvbNX2Z/40326734_1_urbani_white_truffle_oil.webp" },
        ],
      },
      "Tofu & Mushrooms": {
        products: [
          { name: "Silken Tofu Firm", brand: "Mori Nu", size: "349g", img: "https://i.postimg.cc/ZKjM078P/1fb97180a15d509e59a54b0e0c666803.png" },
          { name: "Shiitake Mushroom", brand: "Freshos", size: "1kg", img: "https://i.postimg.cc/4ygscdrZ/Shitake-Mushroom.jpg" },
          { name: "Black ", brand: "Imported", size: "1kg", img: "https://i.postimg.cc/qMQ5gbsP/8a67001d31315164f703afff592e698b.png" },
        ],
      },
    },
},
   
   

};

export default PRODUCT_DATA;